export default {"src":"/_next/static/media/Our_services.91eca8ac.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};